(function () {
    const $body = $('body');

    const profileMain = {
        $select: null,

        init: function () {
            profileMain.control();
        },
        control: function () {
            $body.on('change', '#institutionList', function (e) {
                e.preventDefault();
                profileMain.$select = $(this);
                const href = profileMain.$select.val();
                location.href = href;
            });

            $('#institutionList').val(location.toString());
        },
    };

    UX.profileMain = profileMain; // add to global namespace
})();
